import { render, staticRenderFns } from "./MainTypicalcase.vue?vue&type=template&id=de8cf8aa&scoped=true"
import script from "./MainTypicalcase.vue?vue&type=script&lang=js"
export * from "./MainTypicalcase.vue?vue&type=script&lang=js"
import style0 from "./MainTypicalcase.vue?vue&type=style&index=0&id=de8cf8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8cf8aa",
  null
  
)

export default component.exports